import { render, staticRenderFns } from "./CoursewareShelfDialogAdd.vue?vue&type=template&id=6baaa3b4&"
import script from "./CoursewareShelfDialogAdd.vue?vue&type=script&lang=js&"
export * from "./CoursewareShelfDialogAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports